/* eslint-disable no-console */
import {Divider} from 'antd';
import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import ProductInfoTable from '../../../../components/Table/ProductInfoTable';
import Year from '../../../../shared/Year';
// import {yearSelect} from '../../../../utils/FormUtils/yearSelect';
import {checkCurrentYearOrBelow} from '../../../../utils/commonFunctions';

const ProductInfo: React.FC = () => {
  const [searchParam, setSearchParams] = useSearchParams();
  const [selectedYear, setSelectedYear] = useState('');

  // const firstYear = yearSelect();

  useEffect(() => {
    const currentYear = checkCurrentYearOrBelow(
      searchParam.get('selectedYear')
    );
    searchParam.set('selectedYear', currentYear);
    setSearchParams(searchParam);
    setSelectedYear(currentYear);
  }, []);

  return (
    selectedYear && (
      <>
        <Year setSelectedYear={setSelectedYear} />
        <Divider />
        <ProductInfoTable selectedYear={selectedYear} />
      </>
    )
  );
};

export default ProductInfo;
